import { allergiesOptions, limitationsOptions } from '../constants/profileOptions';

// The meal-plan service returns a machine note, e.g.
//   "Meal plan adapted for: ALLERGIES: peanuts, tree_nuts | DIETARY LIMITATIONS: gluten_free"
// This rewrites it into a short, readable note in the dietitian's language.
// Anything that isn't that format (a note the dietitian wrote) is returned untouched.

const PREFIX = /^\s*meal plan adapted for:\s*/i;

const SECTIONS = {
  'ALLERGIES': { en: 'Allergies', he: 'אלרגיות', options: allergiesOptions },
  'DIETARY LIMITATIONS': { en: 'Diet', he: 'תזונה', options: limitationsOptions },
  'MEDICAL CONDITIONS': { en: 'Medical', he: 'רפואי', options: [] },
  'CLIENT PREFERENCES': { en: 'Preferences', he: 'העדפות', options: [] },
};

const labelFor = (raw, options, he) => {
  const value = raw.trim();
  const key = value.toLowerCase().replace(/[\s-]+/g, '_');
  const match = options.find((o) => o.value === key);
  if (match) return he ? match.labelHe : match.labelEn;
  // Unknown code: "tree_nuts" → "tree nuts"
  return value.replace(/_/g, ' ');
};

export function friendlyPlanNote(note, language = 'english') {
  if (!note || typeof note !== 'string' || !PREFIX.test(note)) return note || '';
  const he = language === 'hebrew';

  const lines = note
    .replace(PREFIX, '')
    .split('|')
    .map((part) => {
      const idx = part.indexOf(':');
      if (idx < 0) return null;
      const section = SECTIONS[part.slice(0, idx).trim().toUpperCase()];
      if (!section) return null;
      const body = part.slice(idx + 1).trim();
      if (!body) return null;
      // Preferences are free text; everything else is a comma list of codes.
      const text = section.options.length || section.en === 'Medical'
        ? body.split(',').map((v) => labelFor(v, section.options, he)).filter(Boolean).join(', ')
        : body;
      const label = he ? section.he : section.en;
      return `• ${label}: ${he ? text : text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()}`;
    })
    .filter(Boolean);

  if (!lines.length) return '';
  const intro = he ? 'התפריט הותאם לצרכים של הלקוח/ה:' : "This plan is tailored to the client's needs:";
  return [intro, ...lines].join('\n');
}
